import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { TeacherInterview } from 'web/components/common/modal';

import { getMediaKeyRequest } from 'shared/actions/mediaInfo.action';

@withRouter
@connect(
  (state, props) => ({
    auth: state.shared.auth,
    modal: state.shared.modal,
  }),
  { getMediaKeyRequest },
)
class TeacherInterviewContainer extends Component {
  state = {};

  componentDidMount() {}
  handleSubmit = e => {
    console.log(`handleSubmit`);
  };

  getMediaKeyRequest = mediaUrl => {
    return this.props.getMediaKeyRequest({
      type: '',
      step: '',
      mediaUrl,
    });
  };

  render() {
    const { modal = {} } = this.props;
    const { data = {} } = modal;

    return (
      <TeacherInterview
        handlePopup={this.props.popupHandler}
        handleOneToOne={() => {
          alert('준비중인 기능입니다.');
        }}
        data={data}
        getMediaKeyRequest={this.getMediaKeyRequest}
      />
    );
  }
}

export default TeacherInterviewContainer;
